// Die Bausteine der Datenverträge: Kennung, Zeitpunkt, Pflicht- und
// freiwillige Felder, Name und Adresse – EINE Quelle für den Vertrag der
// Besichtigung (aufnahme-vertrag.ts) und den fürs Büro (buero-vertrag.ts).
//
// Warum eine eigene Datei (seit E3, Schritt 1, Teil 2): Die Doku-App schickt
// seit E3 auch Fragen, Antworten, „erledigt“ und den Montagetermin über
// ihren Eingang – die Einträge dafür bauen auf den Regeln des Büro-Vertrags
// auf. Dann braucht der Vertrag der Besichtigung den des Büros; stünden die
// Bausteine weiter dort, bräuchte jeder den anderen, und einer von beiden
// fände beim Laden seine Bausteine noch nicht vor. Hier hängen beide an
// dieser Datei, sie selbst an nichts aus den Verträgen.

import * as z from "zod";
import { istKennung } from "./kennung.ts";

/** Eine Kennung wie aus `neueKennung()`: UUID, Kleinbuchstaben. */
export const kennung = z.string().refine(istKennung, "Keine gültige Kennung.");

/** Ein Zeitpunkt als ISO-Text, wie ihn `Date.toISOString()` liefert. */
export const zeitpunkt = z.iso.datetime({ offset: true, message: "Kein gültiger Zeitpunkt." });

/** Ein Pflichtfeld, wie Menschen es tippen: getrimmt, nicht leer, nicht endlos. */
export const pflicht = (max: number, meldung: string) => z.string().trim().min(1, meldung).max(max);

/** Ein freiwilliges Feld: leer zählt als „nicht angegeben“. */
export const freiwillig = (max: number) =>
  z
    .string()
    .trim()
    .max(max)
    .nullable()
    .transform((s) => s || null);

/** Eine E-Mail-Adresse, freiwillig: leer zählt als „nicht angegeben“ – am Kunden und (seit E3c) an den Ansprechpartnern. */
export const email = z
  .string()
  .trim()
  .toLowerCase()
  .max(200)
  .refine((s) => s === "" || z.email().safeParse(s).success, "Bitte eine gültige E-Mail-Adresse eingeben.")
  .nullable()
  .transform((s) => s || null);

/**
 * Was Menschen am Kunden tippen – in der Doku-App beim Anlegen, im Büro beim
 * Berichtigen (E3, buero-vertrag.ts): dieselben Regeln an beiden Stellen.
 */
export const kundeFelder = {
  name: pflicht(120, "Bitte einen Namen eingeben."),
  telefon: freiwillig(40),
  email,
};

/**
 * Vorname und Nachname (seit E3b, O82) – beide freiwillig im Vertrag: Ein
 * Gerät mit altem Stand schickt sie nicht, dann gilt `name` allein. Kommt ein
 * Nachname, setzt der Server `name` daraus zusammen (name.ts). Pflicht ist
 * der Nachname nur im Formular, wo es ihn gibt.
 */
export const namensFelder = {
  vorname: freiwillig(60).optional(),
  nachname: freiwillig(80).optional(),
};

/** Die Adresse des Objekts – wie kundeFelder in beiden Apps gleich. */
export const objektFelder = {
  strasse: pflicht(200, "Bitte Straße und Hausnummer eingeben."),
  plz: pflicht(10, "Bitte die PLZ eingeben."),
  ort: pflicht(120, "Bitte den Ort eingeben."),
};
